module.exports = __webpack_public_path__ + "static/media/bower.49341509.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/bower.png
// module id = 78
// module chunks = 0